export default {"src":"/_next/static/media/badass-badge-censored-light.919fc380.svg","height":56,"width":170,"blurWidth":0,"blurHeight":0};